var _circle, _circle2, _circle3, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 67.9982,
    cy: 67.9999,
    r: 67.3263,
    stroke: "url(#paint0_linear_19134_32378)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 68.0011,
    cy: 68.0001,
    r: 43.4386,
    stroke: "url(#paint1_linear_19134_32378)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 30,
    fill: "#1E1E2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 68.0174C38 51.4588 51.4653 38 68 38C84.5347 38 98 51.4588 98 68.0174C98 84.5412 84.5347 98 68 98C51.4653 98 38 84.5412 38 68.0174ZM79.0053 71.0537C79.3238 70.7353 79.7292 70.2432 79.8161 70.1275C80.2794 69.5197 80.5111 68.7671 80.5111 68.0175C80.5111 67.1752 80.2505 66.3938 79.7582 65.757C79.7179 65.7167 79.6389 65.6307 79.5359 65.5186C79.3433 65.309 79.0668 65.008 78.8026 64.744C76.4281 62.1969 70.2312 58.0291 66.9879 56.7555C66.4957 56.5558 65.2505 56.1188 64.5845 56.0898C63.9474 56.0898 63.3393 56.2346 62.7601 56.524C62.0362 56.9292 61.457 57.566 61.1385 58.3185C60.9358 58.8395 60.6173 60.4024 60.6173 60.4314C60.2987 62.139 60.125 64.9176 60.125 67.9856C60.125 70.9118 60.2987 73.5718 60.5594 75.3084C60.5665 75.3155 60.5914 75.4397 60.6301 75.6327C60.7478 76.2193 60.9929 77.4413 61.2543 77.9422C61.8914 79.1579 63.1366 79.9104 64.4686 79.9104H64.5845C65.4532 79.8815 67.2775 79.1289 67.2775 79.1C70.347 77.8265 76.3991 73.8612 78.8316 71.2273L79.0053 71.0537Z",
    fill: "url(#paint2_linear_19134_32378)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19134_32378",
    x1: 67.9982,
    y1: 1.17358,
    x2: 67.9982,
    y2: 134.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19134_32378",
    x1: 68.0011,
    y1: 25.0615,
    x2: 68.0011,
    y2: 110.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_19134_32378",
    x1: 68,
    y1: 38,
    x2: 68,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD99"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksPlay);
export default __webpack_public_path__ + "static/media/how-it-works-play.47fb347ab254d79551cb1e3fc4519f49.svg";
export { ForwardRef as ReactComponent };